import React from "react";
import { Routes, Route } from "react-router-dom";

import { OwnerRoutes } from "../Router/ownerRoutes";
import { TenantRoutes, WorkerRoutes } from "../Router/tenantRouts";
import { CommonRoutes } from "../Router/commonRoutes";
import { ManagertRoutes } from "../Router/managerRoutes";
import { AccountantRoutes } from "../Router/accountantRoutes";
import { RmaDeveloperRoutes } from "../Router/rmaDeverloperRoutes";

export default function AppRouter() {
  return (
    <Routes>
      {/* RMA_developer Part  */}
      {RmaDeveloperRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}

      {/* Owner part */}

      {OwnerRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}

      {/* Tenant part */}

      {TenantRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}

      {/* Worker part */}

      {WorkerRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}

      {/* Manager Part */}

      {ManagertRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}

      {/* Accountant part */}

      {AccountantRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}

      {/* common path */}
      {CommonRoutes.map((route, index) => (
        <Route path={route.path} element={route.Component} key={route.Title} />
      ))}
    </Routes>
  );
}
